<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

document.querySelectorAll('a[href="#CategoryJumpToolbar"]').forEach(anchor => {
  
  // Smooth scroll
  anchor.addEventListener('click', function (e) {
    e.preventDefault();
    document.querySelector('#CategoryJumpToolbar').scrollIntoView({
      behavior: 'smooth'
    });
  });

  if (!anchor.querySelector('.sub-image')) {
    const img = document.createElement('img');
    img.className = 'sub-image';
    img.src = "https://cdn.shopify.com/s/files/1/0750/5618/5565/files/category-logo-new.png?v=1756662897";
    img.alt = "View All";

    const span = anchor.querySelector('.sub-title');
    if (span) {
      anchor.insertBefore(img, span);
    } else {
      anchor.appendChild(img); // fallback
    }
  }
});

document.addEventListener('click', function (event) {
  const thumb = event.target.closest('.product-card-thumb');

  if (thumb) {
    event.preventDefault();
    event.stopPropagation();

    changeProductCardImage(thumb);
    return;
  }

  const dot = event.target.closest('.product-card-mobile-dot');

  if (dot) {
    event.preventDefault();
    event.stopPropagation();

    const productCard = dot.closest('.product-item');
    if (!productCard) return;

    const dots = Array.from(productCard.querySelectorAll('.product-card-mobile-dot'));
    const dotIndex = dots.indexOf(dot);

    if (dotIndex === -1) return;

    const thumbs = Array.from(productCard.querySelectorAll('.product-card-thumb'));
    if (!thumbs[dotIndex]) return;

    changeProductCardImage(thumbs[dotIndex]);
  }
});

function changeProductCardImage(thumb) {
  const productCard = thumb.closest('.product-item');
  if (!productCard) return;

  const mainImage = productCard.querySelector('.card-media img');
  if (!mainImage) return;

  const newImage = thumb.dataset.mainImage;
  const newSrcset = thumb.dataset.mainSrcset;
  const currentIndex = Array.from(productCard.querySelectorAll('.product-card-thumb')).indexOf(thumb);

  if (newImage) {
    mainImage.src = newImage;
  }

  if (newSrcset) {
    mainImage.srcset = newSrcset;
  }

  productCard.querySelectorAll('.product-card-thumb').forEach(function (item) {
    item.classList.remove('active');
  });

  thumb.classList.add('active');

  productCard.querySelectorAll('.product-card-mobile-dot').forEach(function (dot, index) {
    if (index === currentIndex) {
      dot.classList.add('active');
    } else {
      dot.classList.remove('active');
    }
  });
}

document.addEventListener('touchstart', function (event) {
  const media = event.target.closest('.card-media');
  if (!media) return;

  media.dataset.touchStartX = event.touches[0].clientX;
}, { passive: true });

document.addEventListener('touchend', function (event) {
  const media = event.target.closest('.card-media');
  if (!media) return;

  const productCard = media.closest('.product-item');
  if (!productCard) return;

  const startX = Number(media.dataset.touchStartX || 0);
  const endX = event.changedTouches[0].clientX;
  const diffX = startX - endX;

  if (Math.abs(diffX) < 40) return;

  const thumbs = Array.from(productCard.querySelectorAll('.product-card-thumb'));
  if (!thumbs.length) return;

  let currentIndex = thumbs.findIndex(function (thumb) {
    return thumb.classList.contains('active');
  });

  if (currentIndex === -1) {
    currentIndex = 0;
  }

  let nextIndex;

  if (diffX > 0) {
    nextIndex = currentIndex + 1;

    if (nextIndex >= thumbs.length) {
      nextIndex = 0;
    }
  } else {
    nextIndex = currentIndex - 1;

    if (nextIndex < 0) {
      nextIndex = thumbs.length - 1;
    }
  }

  changeProductCardImage(thumbs[nextIndex]);
}, { passive: true });

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
